import { Injectable, computed, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { environment } from './environment';
import { User } from './models';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private tokenKey = 'lms_token';
  user = signal<User | null>(this.readUser());
  isLoggedIn = computed(() => !!this.token);
  role = computed(() => this.user()?.role || null);

  constructor(private http: HttpClient, private router: Router) {}

  get token(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  login(email: string, password: string) {
    return this.http.post<any>(`${environment.apiUrl}/auth/login`, { email, password }).pipe(
      tap(res => this.setSession(res))
    );
  }

  register(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/auth/register`, data).pipe(
      tap(res => this.setSession(res))
    );
  }

  me() {
    return this.http.get<any>(`${environment.apiUrl}/auth/me`).pipe(
      tap(res => {
        const u = res.user || res.data || res;
        this.user.set(u);
        localStorage.setItem('lms_user', JSON.stringify(u));
      })
    );
  }

  logout() {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem('lms_user');
    this.user.set(null);
    this.router.navigate(['/login']);
  }

  private setSession(res: any) {
    const token = res.token || res.accessToken;
    const user = res.user || res.data?.user || res.data;
    if (token) localStorage.setItem(this.tokenKey, token);
    if (user) {
      localStorage.setItem('lms_user', JSON.stringify(user));
      this.user.set(user);
    }
  }

  private readUser(): User | null {
    try { return JSON.parse(localStorage.getItem('lms_user') || 'null'); }
    catch { return null; }
  }
}
